import { useGrowthBook as useGrowthbookFromPackage, GrowthBook } from '@growthbook/growthbook-react'
import { AppFeatures } from 'types/app-features'
import { assertExists } from './assert'

type FeatureKey = keyof AppFeatures

export const useGrowthBook = (): GrowthBook<AppFeatures> => {
  const gb = useGrowthbookFromPackage<AppFeatures>()
  assertExists(gb)
  return gb
}

export const useFeatureIsOn = (id: FeatureKey) => {
  const gb = useGrowthBook()
  return gb.isOn(id)
}

export const useFeatureValue = <Fallback extends boolean>(id: FeatureKey, fallback: Fallback) => {
  const gb = useGrowthBook()
  return gb.getFeatureValue(id, fallback)
}
